import { FC } from "react";
import {
  AddingCriteria,
  AdvancedDeclarationOption,
  AllotmentPolicies,
  EditAllotmentPoliciesLocationValues,
  LocationGrainTrackerValues,
  PrincipalInfoGT,
  QualityCriteriaData,
} from "../../../../../redux/slices/grainTracker/grainTrackerTypes";
import FormCurrentCharacteristics from "./qualityCriteriaParts/FormCurrentCharacteristics";
import CreateQualityCriteriaInputs from "./qualityCriteriaParts/FormInputsQualityCriteriaSelect";
import { DataSBFilterValues } from "../../../../../redux/actions/dataTable/DataTableTypes";

type QualityCriteriaInformationGrainTrackerParams = {
  t: (arg0: string) => string;
  qualityCriteria: {
    data: QualityCriteriaData[];
    total: number;
    limit: number;
    loading: boolean;
    error: string;
  };

  AllotmentPolicies: AllotmentPolicies[];
  qualityCriteriaData: QualityCriteriaData[];
  setCriteriaValuesToDelete: (values: string[]) => void;
  selectedCriteriaToDelete: string[];

  addingCriteria: AddingCriteria;
  selectedCriteriaV: (values: any) => void;
  setCriteriaToBin: (addingCriteria: AddingCriteria) => void;
  addOptionCriteriaByDefault: QualityCriteriaData[];
  locationGrainTrackerValues: LocationGrainTrackerValues;
  principalInfoGT: PrincipalInfoGT;
  editBins: EditAllotmentPoliciesLocationValues;

  selectedCriteriaTemplate: QualityCriteriaData[];

  resetAddingCriteria: () => void;
  setAdvancedDeclarationOptionText: (
    advancedDeclarationOption: AdvancedDeclarationOption,
    searchText: string
  ) => void;
  advancedDeclarationOption: AdvancedDeclarationOption;
  setAvancedDeclarationOptionSelected: (values: {
    allValuesSelected: boolean;
    valuesSelected: DataSBFilterValues[];
  }) => void;
  advancedDeclarationOptionSelected: {
    allValuesSelected: boolean;
    valuesSelected: DataSBFilterValues[];
  };
  selectedCriteria: string | undefined;
};

export const QualityCriteriaInformationGrainTracker: FC<
  QualityCriteriaInformationGrainTrackerParams
> = ({
  t,
  qualityCriteria,
  AllotmentPolicies,
  qualityCriteriaData,
  setCriteriaValuesToDelete,
  selectedCriteriaToDelete,
  addingCriteria,
  selectedCriteria,
  selectedCriteriaV,
  setCriteriaToBin,
  addOptionCriteriaByDefault,
  locationGrainTrackerValues,
  principalInfoGT,
  editBins,
  selectedCriteriaTemplate,
  setAdvancedDeclarationOptionText,
  setAvancedDeclarationOptionSelected,
  resetAddingCriteria,
  advancedDeclarationOption,
  advancedDeclarationOptionSelected,
}) => {
  return (
    <div>
      {qualityCriteria.data.length >= 1 ? (
        <div className="info-title-graintracker mt-3">
          {t("Grain_tracker.allotment-title")}
        </div>
      ) : (
        ""
      )}
      <FormCurrentCharacteristics
        t={t}
        AllotmentPolicies={AllotmentPolicies}
        qualityCriteriaData={qualityCriteriaData}
        setCriteriaValuesToDelete={setCriteriaValuesToDelete}
        selectedCriteriaToDelete={selectedCriteriaToDelete}
      />

      <CreateQualityCriteriaInputs
        t={t}
        qualityCriteria={qualityCriteria}
        addingCriteria={addingCriteria}
        selectedCriteriaV={selectedCriteriaV}
        setCriteriaToBin={setCriteriaToBin}
        addOptionCriteriaByDefault={addOptionCriteriaByDefault}
        locationGrainTrackerValues={locationGrainTrackerValues}
        principalInfoGT={principalInfoGT}
        editBins={editBins}
        selectedCriteria={selectedCriteria}
        selectedCriteriaTemplate={selectedCriteriaTemplate}
        setAdvancedDeclarationOptionText={setAdvancedDeclarationOptionText}
        setAvancedDeclarationOptionSelected={
          setAvancedDeclarationOptionSelected
        }
        resetAddingCriteria={resetAddingCriteria}
        advancedDeclarationOption={advancedDeclarationOption}
        advancedDeclarationOptionSelected={advancedDeclarationOptionSelected}
      />
    </div>
  );
};

export default QualityCriteriaInformationGrainTracker;
